import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/** Company panel → Breathwork: sessions, audio and the employee list. */
const CompanyBreathworkLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const population = isB2BFansMode ? 'members' : 'employees';

  const pages = [
    {
      label: 'Tracker Dashboard',
      path: `/${slug}/breathwork`,
      description: 'Sessions, minutes and technique mix'
    },
    {
      label: 'Audio Dashboard',
      path: `/${slug}/breathwork/audio`,
      description: 'Which guided audio gets played'
    },
    {
      label: isB2BFansMode ? 'Members' : 'Employees',
      path: `/${slug}/breathwork/users`,
      description: `Per-${population.replace(/s$/, '')} breathwork records`
    }
  ];

  return (
    <CompanySectionLayout
      title="Breathwork"
      subtitle={`How often your ${population} breathe, and what they practise with.`}
      pages={pages}
      reportFeatureKey="breathwork"
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanyBreathworkLayout;
